import Header from "./Header";
import Footer from "./Footer";
import Section from "./Section";
import styles from "../App.module.scss";

export const Main = () => {

    return (
        <>
            <Header />
            <main className={styles["l-main"]}>
                <Section />
            </main>
            <Footer />
        </>
    );
}